import { render } from "./StatusBasedBilledCases.vue?vue&type=template&id=0ca4bad8&scoped=true"
import script from "./StatusBasedBilledCases.vue?vue&type=script&lang=js"
export * from "./StatusBasedBilledCases.vue?vue&type=script&lang=js"

import "./StatusBasedBilledCases.vue?vue&type=style&index=0&id=0ca4bad8&lang=scss&scoped=true"
import "./StatusBasedBilledCases.vue?vue&type=style&index=1&id=0ca4bad8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4bad8"],['__file',"src/components/cases/StatusBasedBilledCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca4bad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca4bad8', __exports__)) {
    console.log('reload')
    api.reload('0ca4bad8', __exports__)
  }
  
  module.hot.accept("./StatusBasedBilledCases.vue?vue&type=template&id=0ca4bad8&scoped=true", () => {
    console.log('re-render')
    api.rerender('0ca4bad8', render)
  })

}


export default __exports__